import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from "./quasar-user-options"
import "./registerServiceWorker"
import dateMessage from "@/utils/returnDateMessage";
import formatMessage from "@/utils/formatMessage";

const app = createApp(App);

// Exportados globalmente
app.config.globalProperties.$dateMessage = dateMessage;
app.config.globalProperties.$formatMessage = formatMessage;
app.config.globalProperties.$router = router;

app
    .use(Quasar, quasarUserOptions)
    .use(store)
    .use(router)
    .mount("#app");